import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AdminService } from '../../admin.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AdminItemContainerDirective } from '@app/main/admin/directives/admin-item-container.directive';
import { IFilter, IUser } from '@shared/interfaces';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-users',
    templateUrl: './admin-users.component.html',
    styleUrls: ['./admin-users.component.scss'],
    animations: [
        trigger('comeUp', [
            state(
                'void',
                style({
                    opacity: 0
                })
            ),
            state(
                '*',
                style({
                    opacity: 1
                })
            ),
            transition('void => *', [animate(500)]),
            transition('* => void', [])
        ])
    ],
    standalone: false
})
export class AdminUsersComponent extends AdminItemContainerDirective implements AfterViewInit, OnInit, OnDestroy {
    constructor(
        adminService: AdminService,
        dialogService: DialogService,
        changeDetector: ChangeDetectorRef,
        moduleService: ModuleService
    ) {
        super(changeDetector, adminService, dialogService, moduleService);
    }

    applyFilter(event: IFilter) {
        if (event?.sortBy && !event?.value) {
            this.data = this.getCopy(this._data);
        } else if (event?.sortBy === 'certificateExpiration') {
            this.data = (this.getCopy(this._data) as IUser[]).sort(
                (a, b) =>
                    (event?.value === 'ASC' ? 1 : -1) *
                    (new Date(a.certificateExpiration).getTime() - new Date(b.certificateExpiration).getTime())
            );
        }
    }
}
